<script setup>
import { Head } from '@inertiajs/vue3'
import { useI18n } from 'vue-i18n'
import PublicLayout from '@/Layouts/PublicLayout.vue'
import InquireForm from '@/Components/Public/InquireForm.vue'

defineOptions({ layout: PublicLayout })

const { t } = useI18n()
</script>

<template>
  <Head><title>{{ t('public.tours.head_title') }}</title></Head>
  <section class="page">
    <h1 class="page__title">{{ t('public.tours.title') }}</h1>
    <p class="page__lede">{{ t('public.tours.lede') }}</p>
    <InquireForm topic="tour" />
  </section>
</template>

<style scoped>
.page { max-width: 40rem; margin: 0 auto; padding: 2.5rem 1.5rem 4rem; width: 100%; }
.page__title { font-family: var(--font-display, var(--display)); font-size: clamp(1.75rem, 4vw, 2.25rem); margin: 0 0 0.5rem; color: var(--ink); font-weight: 700; }
.page__lede  { color: var(--inkSoft); margin: 0 0 2rem; line-height: 1.6; }
</style>
